/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import IndeepWeb from './components/Indeep';
import About from './components/About';
import Contact from './components/Contact';
import News from './components/News';
import How from './components/How';
import Tutorials from './components/Tutorials';
import Credits from './components/Credits';
import Footer from './components/Footer';

import 'tw-elements';
import "./index.css";

class App extends Component {
  

  componentDidMount() {
    var event = new Event('toggletheme');
    var themeToggleDarkIcon = document.getElementById('theme-toggle-dark-icon');
    var themeToggleLightIcon = document.getElementById('theme-toggle-light-icon');
    if (localStorage.getItem('color-theme') === 'dark' || (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      themeToggleLightIcon.classList.remove('hidden');
      document.documentElement.classList.add('dark');
      localStorage.setItem('color-theme', 'dark');
    } else {
      themeToggleDarkIcon.classList.remove('hidden');
      document.documentElement.classList.remove('dark');
      localStorage.setItem('color-theme', 'light');
    }

    var themeToggleBtn = document.getElementById('theme-toggle');

    themeToggleBtn.addEventListener('click', function () {

      // toggle icons inside button
      themeToggleDarkIcon.classList.toggle('hidden');
      themeToggleLightIcon.classList.toggle('hidden');

      // if set via local storage previously
      if (localStorage.getItem('color-theme')) {
        if (localStorage.getItem('color-theme') === 'light') {
          document.documentElement.classList.add('dark');
          localStorage.setItem('color-theme', 'dark');
        } else {
          document.documentElement.classList.remove('dark');
          localStorage.setItem('color-theme', 'light');
        }

        // if NOT set via local storage previously
      } else {
        if (document.documentElement.classList.contains('dark')) {
          document.documentElement.classList.remove('dark');
          localStorage.setItem('color-theme', 'light');
        } else {
          document.documentElement.classList.add('dark');
          localStorage.setItem('color-theme', 'dark');
        }
      }
      document.dispatchEvent(event);
    });
  }

  render() {
    return (
      <Router>
        <div className="font-outfit bg-gradient-to-b from-white to-blue-300 dark:from-black dark:to-sky-900/50">
      
        <nav
          className="font-bold bg-white dark:bg-black">
          <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
            
            <div className="flex space-x-1">
            <Link to={'/'}>
              <div className='flex'>
                <img src="/pasteur-white.png" alt="Institut Pasteur" title="Institut Pasteur" className="h-16 p-2 hidden dark:block" />
                <img src="/LogoIP.png" alt="Institut Pasteur" title="Institut Pasteur" className="h-16 p-2 block dark:hidden" />
                <img src="/indeep_logo_new.png" className="h-16 p-2" alt="Indeep Logo" />
                </div>
            </Link>
            </div>
            <div id="navelem" className="flex space-x-1">
                <Link to={'/about'}
                  className="block p-2 sm:inline-block text-gray-700 hover:text-blue-700 hover:bg-blue-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-700 rounded">About</Link>
                <Link to={'/tutorials'}
                  className="block p-2 sm:inline-block text-gray-700 hover:text-blue-700 hover:bg-blue-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-700 rounded">Tutorials</Link>
                <Link to={'/contact'}
                  className="block p-2 sm:inline-block text-gray-700 hover:text-blue-700 hover:bg-blue-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-700 rounded">Contact</Link>
            </div>
            <div className="flex space-x-1">
              <button id="theme-toggle" type="button" aria-label='theme-button'
                className="text-gray-500 dark:text-gray-400 hover:bg-blue-100 dark:hover:bg-gray-700 rounded-lg text-lg p-2.5">
                <svg id="theme-toggle-dark-icon" className="hidden w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"></path>
                </svg>
                <svg id="theme-toggle-light-icon" className="hidden w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                    fillRule="evenodd" clipRule="evenodd"></path>
                </svg>
              </button>
            </div>
          </div>
        </nav>
        <Routes>
          <Route exact path='/' element={<IndeepWeb />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/about' element={<About />} />
          <Route path='/tutorials' element={<Tutorials />} />
          <Route path='/credits' element={<Credits />} />
          <Route path='/how' element={<How />} />
          <Route path='/news' element={<News />} />
        </Routes>
        
        <Footer />

        </div>
      </Router>
    );
  }
}

export default App;